import {
  Checkbox,
  FormControlLabel,
  ListItemIcon,
  TableCell,
  TableRow,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Menu } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function FeaturedJobDetailTableCell(props) {
  const classes = useStyles(props);

  function changeSelected(index) {
    var temp = [...props.tableData];
    temp[index].selected = !temp[index].selected;
    props.setTableData(temp);
  }

  return (
    <>
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Selected" ? (
              <FormControlLabel
                style={{ marginTop: "10px" }}
                control={
                  <Checkbox
                    color="primary"
                    checked={props.element.selected}
                    onChange={() => changeSelected(props.index)}
                  />
                }
                label=""
              />
            ) : column.label === "" ? (
              <ListItemIcon className={classes.itemIcon}>
                <Menu />
              </ListItemIcon>
            ) : (
              props.element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
